import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PutShiftSettingRegionEntity } from '../../domain/entities/PutShiftSettingRegionEntity'

export class PutShiftSettingRegionModel extends PutShiftSettingRegionEntity {
  regionId?: number
  constructor(dataDto: PutShiftSettingRegionEntity) {
    super()
    mapEntityProperties<PutShiftSettingRegionModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id
      }
    })
  }
}
